import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UIIcon = _resolveComponent("UIIcon")!
  const _component_PopoverButton = _resolveComponent("PopoverButton")!
  const _component_ActionMenuPopover = _resolveComponent("ActionMenuPopover")!

  return (_openBlock(), _createBlock(_component_ActionMenuPopover, {
    actionMenuItems: _ctx.menuOptions,
    onOnActionMenuClick: _cache[0] || (_cache[0] = item => _ctx.$emit('onMenuItemClick', item)),
    context: _ctx.context
  }, {
    popoverButton: _withCtx(() => [
      _createVNode(_component_PopoverButton, { class: "h-full bg-transparent hover:bg-white hover:text-gray-900 text-white py-2 px-3 leading-4 text-sm inline-flex items-center justify-center rounded focus:outline-none transition ease-in-out duration-150 border border-transparent font-medium focus:outline-none" }, {
        default: _withCtx(() => [
          _createVNode(_component_UIIcon, {
            icon: "heroicons-solid:dots-vertical",
            class: "w-5 h-5"
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["actionMenuItems", "context"]))
}